<template>

</template>

<script>
export default {
name: "popularCities"
}
</script>

<style scoped>

</style>
